import { WorkItemsStatusVoData, WorkItemStatusVoData, WorkItemTypeOptionsVoData } from "../..";
import { CheckUtils } from "../../index";
var WorkItemsConverter = /** @class */ (function () {
    function WorkItemsConverter() {
    }
    WorkItemsConverter.convertToTypeOptionsVoData = function (workItemOptionsTypesApiData) {
        var workItemOptionsTypeVoData = [];
        if (!CheckUtils.isEmpty(workItemOptionsTypesApiData)) {
            for (var _i = 0, workItemOptionsTypesApiData_1 = workItemOptionsTypesApiData; _i < workItemOptionsTypesApiData_1.length; _i++) {
                var type = workItemOptionsTypesApiData_1[_i];
                var workItemtype = new WorkItemTypeOptionsVoData(type.name);
                workItemtype.itemType = type.itemType;
                workItemtype.iconStyleName = type.iconStyleName;
                workItemtype.iconColor = type.iconColor;
                workItemtype.visible = type.visible;
                workItemOptionsTypeVoData.push(workItemtype);
            }
        }
        return workItemOptionsTypeVoData;
    };
    WorkItemsConverter.convertToWorkItemStatusesVoData = function (workItemStatusesApiData) {
        var _this = this;
        var workItemsStatusesVoData = [];
        if (!CheckUtils.isEmpty(workItemStatusesApiData) && workItemStatusesApiData instanceof Map) {
            workItemStatusesApiData.forEach(function (value, key) {
                var workItemsStatusVoData = new WorkItemsStatusVoData(key);
                workItemsStatusVoData.statuses = _this.convertToStatusesVoData(value);
                workItemsStatusesVoData.push(workItemsStatusVoData);
            });
        }
        return workItemsStatusesVoData;
    };
    WorkItemsConverter.convertToStatusesVoData = function (workItemStatusesApiData) {
        var statusesVoData = [];
        if (!CheckUtils.isEmpty(workItemStatusesApiData)) {
            for (var _i = 0, workItemStatusesApiData_1 = workItemStatusesApiData; _i < workItemStatusesApiData_1.length; _i++) {
                var workItemStatusApiData = workItemStatusesApiData_1[_i];
                var workItemStatus = new WorkItemStatusVoData(workItemStatusApiData.id);
                workItemStatus.label = workItemStatusApiData.label;
                workItemStatus.iconColor = workItemStatusApiData.iconColor;
                workItemStatus.isDefault = workItemStatusApiData.isDefault;
                statusesVoData.push(workItemStatus);
            }
        }
        return statusesVoData;
    };
    return WorkItemsConverter;
}());
export { WorkItemsConverter };
//# sourceMappingURL=work-items-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/work-items-converter.js
// module id = 975
// module chunks = 14